<span matDialogTitle>
  {{ choices().title | siaTranslate }}
</span>
<button mat-icon-button matDialogClose (click)="choiceClick(null)">
  <mat-icon> close </mat-icon>
</button>
<mat-dialog-content>
  @if (choices().description) {
    <div class="mb-4 text-lg text-medium">
      {{ choices().description | siaTranslate }}
    </div>
  }
  <div class="flex flex-col items-center justify-center w-full gap-4">
    @for (item of choices().items; track $index) {
      <button
        mat-stroked-button
        (click)="choiceClick(item)"
        class="w-4/5 big md:w-1/2"
      >
        <mat-icon>{{ item.icon }}</mat-icon>
        <span>{{ item.name | siaTranslate }}</span>
      </button>
    }
  </div>
</mat-dialog-content>
